import { combineReducers } from '@reduxjs/toolkit';
import portfolioSiteExplorerReducer from 'src/app/portfolio/views/portfolio-site-explorer/state/portfolioSiteExplorerSlice';
import gnrFiltersReducer from 'src/app/portfolio/views/global-nature-risk/state/gnrFiltersSlice';
import portfolioGeneralReducer from './portfolioGeneralSlice';

export const portfolio = combineReducers({
    portfolioGeneral: portfolioGeneralReducer,
    portfolioSiteExplorer: portfolioSiteExplorerReducer,
    gnrFilters: gnrFiltersReducer,
});

export default portfolio;
